// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customFormInput[data-v-c6c850b8] {\n  height: 34px !important;\n  max-height: 34px !important;\n}\n", ""]);
// Exports
module.exports = exports;
